import { useDispatch, useSelector } from "react-redux";

import preCadastroActions from "../../redux/preCadastro/actions";
import { message } from "antd";
import Button from "../../components/button";
import PageTitle from "../../components/pageTitle";
import { BtnGroup, PreCadastroForm, PreCadastroWrapper } from "./styled";
import { StoreState } from "../../redux/reduxTypes";
import { PreCadastroState } from "../../types/state.types";
import { useCallback, useEffect, useMemo, useState } from "react";
import DadosPessoaisPreCadastro from "./dadosPessoais";
import EnderecoContatoPreCadastro from "./enderecoEContato";
import DadosCooperativismoPreCadastro from "./dadosCooperativismo";
import Agendamento from "./agendamento";
import InputLabel from "../../components/inputLabel";
import {
  validarData,
  validarDataNascimento,
} from "../../utils/functions-helper";
import { ConfigsSet, getSessionConfig } from "../../utils/session-helper";
import { useNavigate } from "react-router-dom";

function PreCadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    dados,
    agendamentoBuscado,
    concluido,
    estaCadastrado,
    dadosIniciais,
  } = useSelector<StoreState, PreCadastroState>(
    (state) => state.preCadastroState
  );

  const atualizarDadosPreCadastro = useCallback(
    (dadosForm: object) => {
      dispatch(
        preCadastroActions.setDados({
          ...dados,
          ...dadosForm,
        })
      );
    },
    [dados, dispatch]
  );

  const [agendamento, setAgendamento] = useState<boolean>(false);
  const helpFilePath = useMemo(
    () =>
      `${window.location.origin}${process.env.PUBLIC_URL}/arquivos/Ajuda-Pre-Cadastro.pdf`,
    []
  );
  const [hasFile, setHasFile] = useState(false);

  useEffect(() => {
    fetch(helpFilePath, { cache: "no-store" })
      .then((resp) => setHasFile(!(resp.status === 404)))
      .catch((e) => console.log({ e }));
  });

  const validaDados = useCallback((): boolean => {
    if (dados.nome.length < 5) {
      message.warning("Por favor, digite seu nome completo");
      return false;
    }
    if (dadosIniciais!.PisObrigatorio) {
      if (!dados.pispasep || dados.pispasep.length === 0) {
        message.warning("PIS/PASEP é obrigatório");
        return false;
      } else if (dados.pispasep.length < 11) {
        message.warning(
          "Preencha o PIS/PASEP corretamente (no formato: xxx.xxxxx.xx-x)"
        );
        return false;
      }
    } else if (dados.pispasep.length > 0 && dados.pispasep.length < 11) {
      message.warning(
        "Preencha o PIS/PASEP corretamente (no formato: xxx.xxxxx.xx-x)\nOu deixe vazio"
      );
      return false;
    }
    if (
      agendamento &&
      (!dados.dataAgendamento ||
        dados.dataAgendamento.includes("((") ||
        !dados.horarioAgendamento ||
        dados.horarioAgendamento.includes("(("))
    ) {
      message.warning("Por favor, seleciuone Data e Hora do seu atendimento");
      return false;
    }
    if (
      !dados.ufID ||
      dados.ufID === "Na" ||
      !dados.cidadeID ||
      dados.cidadeID === 0 ||
      !dados.sexoID ||
      dados.sexoID === 0 ||
      !dados.estadoCivilID ||
      dados.estadoCivilID === 0 ||
      !dados.grauInstrucaoID ||
      dados.grauInstrucaoID === 0 ||
      !dados.ufIDOrgaoExpedidor ||
      dados.ufIDOrgaoExpedidor === "Na" ||
      !dados.ufIDEndereco ||
      dados.ufIDEndereco === "Na" ||
      !dados.paisID ||
      dados.paisID === 0 ||
      !dados.conselhoID ||
      dados.conselhoID === 0 ||
      !dados.categoriaID ||
      dados.categoriaID === 0 ||
      !dados.cep ||
      dados.cep.length !== 8 ||
      !dados.nomeCidade ||
      dados.nomeCidade.length === 0 ||
      !dados.bairro ||
      dados.bairro.length === 0 ||
      !dados.logradouro ||
      dados.logradouro.length === 0 ||
      !dados.numeroLogradouro ||
      dados.numeroLogradouro.length === 0 ||
      !dados.rg ||
      dados.rg.length === 0 ||
      !dados.tituloEleitor ||
      dados.tituloEleitor.length === 0 ||
      !dados.email ||
      dados.email.length === 0 ||
      !dados.numeroConselho ||
      dados.numeroConselho.length === 0 ||
      !dados.dataExpedicaoRG ||
      !validarData(dados.dataExpedicaoRG)
    ) {
      message.warning("Por favor, preencha todos os campos obrigatórios");
      return false;
    }
    return true;
  }, [agendamento, dados]);

  const realizarPreCadastro = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      if (validaDados()) {
        dispatch(
          preCadastroActions.preCadastrar({
            ...dados,
            dataAtendimento: dados.horarioAgendamento ?? "",
          })
        );
      }
    },
    [validaDados, dispatch, dados]
  );

  const buscarAgendamentoAtual = useCallback(
    (cpf: string, dtNascimento: string) => {
      if (cpf.length !== 11 || !validarDataNascimento(dtNascimento)) {
        return message.warning(
          "Por favor preencha o CPF e Data de Nascimento corretamente"
        );
      }
      dispatch(preCadastroActions.buscarAgendamentoAtual(cpf, dtNascimento));
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(preCadastroActions.inicializaEstado());
    const configAgendamento = getSessionConfig().Configuracoes?.find(
      (c) => c.ID === ConfigsSet.AgendamentoPreCad
    );
    setAgendamento(configAgendamento ? configAgendamento.Valor === "1" : false);
  }, [dispatch]);

  useEffect(() => {
    if (concluido) navigate("/");
    if (estaCadastrado) {
      alert("Este CPF já está Pré-Cadastrado!");
      dispatch(preCadastroActions.setEstadoInicial());
      navigate("/");
    }
  }, [concluido, dispatch, estaCadastrado, navigate]);

  return (
    <PreCadastroWrapper>
      <PageTitle titulo="Área Restrita - Pré Cadastro" centralizado />

      <PreCadastroForm onSubmit={realizarPreCadastro}>
        <InputLabel
          labelText="CPF"
          labelId="cpf"
          disabled={agendamentoBuscado}
          type="number"
          value={dados.cpf}
          onChange={(value) => atualizarDadosPreCadastro({ cpf: value })}
          required
          column
          mask="999.999.999-99"
        />

        <InputLabel
          labelText="Data de Nascimento"
          labelId="dataNascimento"
          disabled={agendamentoBuscado}
          type="date"
          value={dados.dataNascimento}
          onChange={(value) =>
            atualizarDadosPreCadastro({ dataNascimento: value })
          }
          required
          column
        />

        {agendamentoBuscado ? (
          <>
            <DadosPessoaisPreCadastro />
            <EnderecoContatoPreCadastro />
            <DadosCooperativismoPreCadastro />
            {agendamento ? <Agendamento /> : <></>}

            <Button primary type="submit">
              Finalizar
            </Button>
          </>
        ) : (
          <BtnGroup>
            <span>
              {hasFile && (
                <a target="_blank" rel="noreferrer" href={helpFilePath}>
                  Documentos Necessários para a Cooperação
                </a>
              )}
            </span>

            <Button
              primary
              onClick={(event) => {
                event.preventDefault();
                buscarAgendamentoAtual(dados.cpf, dados.dataNascimento);
              }}
            >
              Continuar
            </Button>
          </BtnGroup>
        )}
      </PreCadastroForm>
    </PreCadastroWrapper>
  );
}

export default PreCadastro;
